export const getAlertStatus = (state) => state.status
export const getOptions = (state) => state.options

export const getOpenCallback = (state) => state.OpenCallback
export const getCloseCallback = (state) => state.CloseCallback
